'use client';

import { ReactNode, createContext, useMemo, useState } from 'react';
import { PagePattern as UIPagePattern } from '@stereoagency/ui';

type Props = {
  children?: ReactNode;
};

type ContextValue = {
  variant: '1' | '2' | '3' | null;
  set(variant: ContextValue['variant']): void;
};

export const PagePatternContext = createContext<ContextValue>({
  variant: null,
  set() {
    throw new Error('Not implemented');
  }
});

export default function PagePattern({ children }: Props) {
  const [variant, setVariant] = useState<ContextValue['variant']>(null);
  const value = useMemo(() => ({ variant, set: setVariant }), [variant]);

  return (
    <PagePatternContext.Provider value={value}>
      <div className="grid grid-cols-1 grid-rows-1 min-h-full">
        {!!variant && <UIPagePattern variant={variant} className="col-start-1 row-start-1 h-full" />}
        <div className="col-start-1 row-start-1 min-h-full">{children}</div>
      </div>
    </PagePatternContext.Provider>
  );
}
